import { IS_BROWSER } from "@smartrr/shared/constants";

import { allowedDomains } from "../consts";
/**
 * @todo: this appears to be something that should be global
 */
export const smartrrDebugInfo = () => {
  if (IS_BROWSER) {
    const reportUnhandled = (event: any | string) => {
      const filename = event.filename || "";

      if (filename !== "" && !allowedDomains.find(domain => filename.startsWith(domain))) {
        return;
      }
    };

    window.addEventListener("error", reportUnhandled);
    window.addEventListener("unhandledrejection", reportUnhandled);

    const config = {
      release: process.env.RELEASE || "N/A",
    };

    Object.freeze(config);

    Object.defineProperty(window, "smartrr_debug_info", {
      enumerable: false,
      configurable: false,
      writable: false,
      value: config,
    });
  }
};
